// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d363114","308":"816dd9f7","430":"6141dc3c","453":"faefd50a","667":"84b16461"}[chunkId] + ".chunk.js";
};